import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IEditIBriefDeliverable } from "@shared/lib/types/briefInfluencerV2";
import {
  BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY,
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  makeBriefDeliverableQueryKey,
} from "../constants";
import { BriefService } from "../services/brief.service";

export function useUpdateBriefDeliverable() {
  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation({
    mutationFn: (data: IEditIBriefDeliverable) =>
      BriefService.updateBriefDeliverable(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, _, { deliverableV2Id }) => {
      ToastService.success("Deliverable updated successfully");
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: makeBriefDeliverableQueryKey(deliverableV2Id),
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
    },
  });

  return {
    update,
    isUpdating,
    isUpdated,
  };
}
